export default {"src":"/_next/static/media/cooking_classes.c3568f99.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};